import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './HomeHeading.module.scss'

/** @type {import("./types").default} */
const HomeHeading = ({ children }) => {
  return (
    <div className={clsx('HomeHeading', classes.root)}>
      <Icon className={classes.logo} icon="getapp-logo" prefix="ga" />
      <h2 className={classes.heading}>{children}</h2>
    </div>
  )
}

export default HomeHeading
